import { daysToExpiration } from '../../../../../utils/daysToExpiration.ts';
import type { FormSegment } from '../../../../types.ts';
import { isSegmentExpired, isSegmentSoonToExpire } from '../../../../utils/hasExpiredSegments.ts';
import { getSegmentAlertProps } from './getSegmentAlertProps.ts';

/**
 * Expiration alert props for a segment, using the same rules as the criteria tab and its sorting.
 */
export const getSegmentExpirationAlertProps = (segment: FormSegment) => {
  const isExpired = isSegmentExpired(segment);
  const isSoonToExpire = !isExpired && isSegmentSoonToExpire(segment);

  return getSegmentAlertProps(false, isExpired, isSoonToExpire, daysToExpiration(segment.expiration_date) ?? 0);
};
